import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Transaction PAN', value: 'trx_pan', width: '150' },
  { text: 'Invoice Number', value: 'invoice_number', },
  { text: 'Merchant Name', value: 'merchant_name', },
  { text: 'MID', value: 'mid', width: '150' },
  { text: 'Merchant PAN', value: 'mpan', width: '150' },
  { text: 'Reff ID', value: 'rrn', width: '150' },
  { text: 'Transaction Type', value: 'trx_type', width: '100', align: 'center', textAlign: 'text-center' },
  { text: 'Issuer Name', value: 'issuer_name',  },
  { text: 'Customer PAN', value: 'customer_pan',  },
  { text: 'Payment Type', value: 'payment_type', width: '150' },
  { text: 'Acquirer Name', value: 'payment_channel', width: '150' },
  { text: 'Amount', value: 'amount', width: '150', align: 'center', textAlign: 'text-right' },
  { text: 'MDR', value: 'amount_mdr', width: '150' },
  { text: 'Net Amount', value: 'amount_net', width: '150' },
  { text: 'Transaction Date', value: 'trx_datetime', width: '150' },
  { text: 'Status Transaksi', value: 'status', width: '100' },
  { text: 'Settlement Status', value: 'settlement_status', width: '100' },
  { text: 'Action', value: 'action', width: '100', align: 'center' },
]);

export const search = {
  trx_datetime: [],
  payment_type: '',
  rrn: '',
  mid: '',
  status: '',
  trx_pan: '',
  invoice_number: '',
};

export const editedItem = {
  bill_num: '',
  merchant_name: '',
  mid: '',
  mpan: '',
  rrn: '',
  qr_method: '',
  qr_type: '',
  trx_type: '',
  customer_pan: '',
  payment_method: '',
  payment_type: '',
  payment_channel: '',
  amount: '',
  currency: '',
  amount_mdr: '',
  net_amount: '',
  trx_datetime: '',
  status: '',
  settlement_status: '',
};